import { getToken } from "features/auth/functions/token";
import { ENDPOINT } from "services/axios/constants/endpoints";
import { HTTPMethods } from "services/axios/types/http";
import { getDataFromRequest } from "services/axios/utility/helper";
import { AppThunk } from "services/redux/rootReducer";
import listAllUsers from "./access.listAllUsers";

const updateUser =
    (params: {
        uid: string;
        optionalFields: {
            role?: string;
            email?: string;
            password?: string;
            displayName?: string;
            confirmPassword?: string;
        };
    }): AppThunk<Promise<any>> =>
    (dispatch) => {
        // remove confirm password
        const clonedOptionalFields = { ...params.optionalFields } as Record<
            string,
            string
        >;

        Object.keys(clonedOptionalFields).forEach(
            (key) =>
                (!clonedOptionalFields[key] || key === "confirmPassword") &&
                delete clonedOptionalFields[key]
        );

        return getDataFromRequest(
            ENDPOINT.FUNCTIONS_API.USERS + params.uid,
            HTTPMethods.PATCH,
            getToken(),
            {
                ...clonedOptionalFields,
            }
        ).then((res) => {
            dispatch(listAllUsers());
            return res;
        });
    };

export default updateUser;
